let autoInvestPreferences = (fcModel: ng.resource.IResourceService) => {
    return fcModel('/api/autoinvestpreferences/:id/', {
        id: '@id',
    });
};

angular
    .module('fundersclub.models')
    .factory('AutoInvestPreferences', autoInvestPreferences);
